export default __webpack_public_path__ + "static/media/Companion.a60cdf27.jpg";